import { JsonObject, JsonProperty } from "ta-json";

import type CultureInfo from "../../culture-info";
import { QuerySortOrder } from "./query-sort-order";
import { SortFieldType } from "./sort-field-type";

/**
 * Indicates how to sort the result of a query.
 */
@JsonObject()
export class Sorting {
    /**
     * The type of the field to sort on.
     */
    @JsonProperty("field_type")
    fieldType?: SortFieldType;
    /**
     * The field to sort on.
     */
    @JsonProperty("field")
    field: string;
    /**
     * The culture to sort in.
     */
    @JsonProperty("culture")
    culture: CultureInfo;
    /**
     * The direction to sort in.
     */
    @JsonProperty("order")
    order: QuerySortOrder;

    constructor(init?: Partial<Sorting>) {
        Object.assign(this, init);
    }
}
